<template>
    <div class="title-block">
        <div class="title-block__left">
            <div class="title-block__title">Адреса</div>
        </div>
    </div>
    <div class="table-controls">
        <div class="me-2">
            <div class="filter-table__input-wrap search-control">
                <input
                    @keyup.delete="onDeleteSearch()"
                    @keyup.enter="onSearch()"
                    type="text"
                    v-model="search"
                    class="search-control__input form-control"
                    placeholder="Поиск"
                >
                <button v-if="!hasSearch" @click="onSearch()" class="search-control__input-btn reset-btn">
                    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7.8 0C9.86869 0 11.8526 0.782651 13.3154 2.17578C14.7782 3.56891 15.6 5.45839 15.6 7.42857C15.6 9.26857 14.892 10.96 13.728 12.2629L14.052 12.5714H15L21 18.2857L19.2 20L13.2 14.2857V13.3829L12.876 13.0743C11.508 14.1829 9.732 14.8571 7.8 14.8571C5.73131 14.8571 3.74735 14.0745 2.28457 12.6814C0.821783 11.2882 0 9.39875 0 7.42857C0 5.45839 0.821783 3.56891 2.28457 2.17578C3.74735 0.782651 5.73131 0 7.8 0ZM7.8 2.28571C4.8 2.28571 2.4 4.57143 2.4 7.42857C2.4 10.2857 4.8 12.5714 7.8 12.5714C10.8 12.5714 13.2 10.2857 13.2 7.42857C13.2 4.57143 10.8 2.28571 7.8 2.28571Z" fill="currentColor"></path>
                    </svg>
                </button>
                <button v-else @click="clearSearch()" class="search-control__input-btn reset-btn">
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M14 4.00004L4 14M3.99996 4L13.9999 14" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                    </svg>
                </button>
            </div>
        </div>
        <div class="selects">
            <v-select class="select"
                label="Бренд"
                v-model="brand"
                :items="brands"
                @update:modelValue="onChangeBrand"
                @update:menu="$removeFocus"
                @click:clear="$removeFocus"
                @click:control="$removeFocus"
                item-title="name"
                item-value="id"
                variant="outlined"
                color="primary"
                clearable
                density="compact">
                <template #no-data>
                    <v-list-item>
                        <span>Данные не найдены</span>
                    </v-list-item>
                </template>
            </v-select>

            <v-select class="select"
                label="Статус"
                v-model="statusStore"
                :items="statuses"
                @update:modelValue="onChangeStatus"
                @update:menu="$removeFocus"
                @click:clear="$removeFocus"
                @click:control="$removeFocus"
                item-title="name"
                item-value="id"
                variant="outlined"
                color="primary"
                clearable
                density="compact">
                <template #no-data>
                    <v-list-item>
                        <span>Данные не найдены</span>
                    </v-list-item>
                </template>
            </v-select>
        </div>
        <div class="float-right">
            <a class="btn brn-primary-fit" @click="showExportModal">Экспорт</a>
        </div>
    </div>
    <table class="table align-middle">
        <thead>
            <tr>
                <th scope="col" v-for="elem in thead">
                    <div class="th-inner ">
                        {{elem}}
                    </div>
                </th>
                <th scope="col" v-if="actions.length > 0">Действия</th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="row in tbody">
                <td v-bind:class = "(row.tbody.status === 1) ? 'color-green' : 'color-red'">{{ row.tbody.status_title }}</td>
                <td>{{ row.tbody.brand_name }}</td>
                <td>{{ row.tbody.number }}</td>
                <td>{{ row.tbody.region_name }}</td>
                <td>{{ row.tbody.city_name }}</td>
                <td>{{ row.tbody.street }}</td>

                <td>{{ row.tbody.devices }}</td>
                <td>{{ row.tbody.devicesActive }}</td>

                <td>{{ row.tbody.worktime }}</td>
                <td v-if="actions.length > 0" class="d-flex flex-row align-items-center">
                    <template v-for="action in actions">
                        <template v-if="action.hasOwnProperty('svg')">
                            <div v-html="action.svg" v-on:click="actionClick(action.emit, row)"></div>
                        </template>
                        <a v-else class="btn btn-info m-1" ref="" v-on:click="actionClick(action.emit, row)">{{action.text}}</a>
                    </template>
                </td>
                <td>{{ row.tbody.comment }}</td>
            </tr>
        </tbody>
    </table>

    <Transition name="fade">
        <div>
            <ExportModal
                v-if="exportModal"
                :filters="filter"
                :file-name="'Адреса'"
                :route-export="route_download_data_xlsx"
            />
        </div>
    </Transition>

    <pagination-element :count="count" :current_page="page" @pageChange="pageChange"></pagination-element>
</template>

<script>
import TableElement from "../../../elements/TableElement";
import PaginationElement from "../../../elements/PaginationElement";
import Address from "../../../models/Address";
import ExportModal from "../../../modals/ExportModal.vue";
import { mapState, mapMutations } from 'vuex/dist/vuex.cjs.js';

export default {
    name: "AddressComponent",
    components: {
        TableElement,
        PaginationElement,
        ExportModal
    },
    props: {
        route_create_page: String,
        route_list: String,
        route_delete: String,
        route_get: String,
        route_edit_page: String,
        route_brands_list: String,
        route_download_data_xlsx: String,
        route_get_statuses: String,
        route_organizations: String,
        route_regions: String,
        route_clients: String,
        current_page: {
            type: Number,
            default: 1
        }
    },
    data: function () {
        return {
            address: new Address({
                route_list: this.route_list,
                route_delete: this.route_delete
            }),

            status: null,
            statuses: [],
            statusStore: null,
            selected_status: null,

            client: null,
            clients: [],

            brand: null,
            brands: [],
            selected_brand : null,

            organization: null,
            organizations: [],

            region: null,
            regions: [],

            search: null,
            searchBrand: '',
            searchClient: '',
            searchNumberPharmacy: '',
            hasSearch: false,

            actions: [],

            thead: [
                'Статус',
                'Бренд',
                'Номер аптеки',
                'Регион',
                'Город',
                'Адрес',
                'Кол-во устройств',
                'Активно устройств',
                'График работы',
                'Комментарий'
            ],

            tbody: [],

            count: 1,
            limit: 50,
            page: 1,
        }
    },
    computed: {
        ...mapState('logs', ['exportModal']),
        filter() {
			return [
                {
					type: 'select',
					name: 'Статус',
                    key: 'status',
					model: this.status,
					options: this.statuses,
                    title: 'name'
				},
                {
					type: 'select',
					name: 'Клиент',
                    key: 'client',
					model: this.client,
					options: this.clients,
                    title: 'name'
				},
				{
					type: 'select',
					name: 'Бренд',
                    key: 'brand',
					model: this.brand,
					options: this.brands,
                    title: 'name'
				},
				{
					type: 'select',
					name: 'Организация',
                    key: 'organization',
					model: this.organization,
					options: this.organizations,
                    title: 'name'
				},
				{
					type: 'select',
					name: 'Регион',
                    key: 'region',
					model: this.region,
					options: this.regions,
                    title: 'name'
				}
			]
		},
    },
    methods: {
        ...mapMutations('logs', ['showExportModal']),
        editLocation: function (item) {
            window.location.href = this.route_edit_page+item.id;
        },
        deleteLocation: function (item) {
            if(item.hasOwnProperty('id'))
            {
                let id = item.id;
                this.address.delete(id).then(this.loadTable);
            }
            else
            {
                console.log('Error: delete_item_undefined');
            }
        },
        loadTable: async function () {
            let response = await this.address.loadTable(
                this.page,
                this.limit,
                this.search,
                this.selected_brand,
                this.selected_status
            );
            this.tbody = response.tbody;
            this.count = response.pages;
        },
        pageChange: function (newPage) {
            this.page = newPage;
            this.loadTable();
        },
        onSearch: async function () {
            this.hasSearch = true;
            this.page = 1;
            await this.loadTable()
        },
        clearSearch: async function() {
            this.search = '';
            this.page = 1;
            await this.loadTable()
        },
        onDeleteSearch: async function () {
            if (this.search && this.search.trim() == '') {
                this.search = null;
                this.page = 1;
                await this.loadTable()
            }
        },
        actionClick: function (emit, item) {
            if(emit == 'deleteItem') {
                let conf = confirm('Вы уверены что хотите удалить запись ?');
                if(!conf) {
                    return;
                }
                if (conf) {
                    this.deleteLocation(item)
                }
            }

            if(emit == 'editItem') {
                this.editLocation(item)
            }
        },
        onChangeBrand: async function (brand_id) {
            this.selected_brand = brand_id;
            await this.loadTable();
        },
        onChangeStatus: async function (status) {
            this.selected_status = status;
            await this.loadTable();
        },
        getBrands: async function () {
            let data = await axios.get(this.route_brands_list, {
                params: { limit: 9999 }
            });
            this.brands = data.data.items;
        },
        getClients: async function () {
            let data = await axios.get(this.route_clients, {
                params: { limit: 9999 }
            });
            this.clients = data.data.items;
        },
        getStatuses: async function () {
            let data = await axios.get(this.route_get_statuses, {
                params: { limit: 9999 }
            });
            this.statuses = data.data;

            for (const key in this.statuses) {
                this.statuses[key] = {
                    id: Number(key) + 1,
                    name: this.statuses[key]
                }
            }
        },
        getOrganizations: async function () {
            let data = await axios.get(this.route_organizations, {
                params: { limit: 9999 }
            });
            this.organizations = data.data.items;
        },
        getRegions: async function () {
            let data = await axios.get(this.route_regions, {
                params: { limit: 9999 }
            });
            this.regions = data.data.items;
        },
    },
    watch: {
        search: {
            handler(newValue) {
                if (newValue === '') {
                    this.hasSearch = false;
                    this.clearSearch();
                }
            }
        },
    },
    mounted() {
        this.loadTable();
        this.getBrands();
        this.getStatuses();
        this.getOrganizations();
        this.getRegions();
        this.getClients();
    }
}
</script>

<style scoped>
    .table-controls {
        display: flex;
        flex-wrap: wrap;
        gap: 12px;
        margin-bottom: 20px;
    }
    .selects {
        min-width: 500px;
        display: flex;
        gap: 16px;
    }
    .select {
        width: 250px;
    }
    .float-right {
        margin-left: auto;
    }
</style>
